import { subYears, endOfDay } from 'date-fns';

// Add a leading zero if the value is less than 10
function padTo2Digits(num) {
  return num.toString().padStart(2, '0');
}

// calculating the maximum allowed date
function getMaxDate() {
  return endOfDay(subYears(new Date(), 18));
}

//calculating the minimum allowed date
function getMinDate() {
  return endOfDay(subYears(new Date(), 120));
}

// Format date of birth
function formatDOB(date) {
  if (!(date instanceof Date) || isNaN(date.getTime())) {
    throw new Error('Invalid date object');
  }
  const year = date.getFullYear();
  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  const day = date.getDate().toString().padStart(2, '0');
  return `${year}-${month}-${day}`;
}

//checks if the connected user is an admin and he belongs to reyedar group
//the email is the sended email to check if the user we want to modify is the same admin or not
function isAdminInReyedarGroupAndUser(groups, currentUserEmail, userEmail) {
  if (!Array.isArray(groups) || !currentUserEmail || !userEmail) {
    return false;
  }
  return isSameUser(currentUserEmail, userEmail) && isInReyedarGroup(groups);
}
//checks if the connected user is the same user we want to modify
function isSameUser(currentUserEmail, userEmail) {
  if (!currentUserEmail) {
    return 'No current user email';
  }
  if (!userEmail) {
    return 'No user email';
  }
  return currentUserEmail === userEmail;
}
// checks if the connected user belongs to  Reyedar group
function isInReyedarGroup(groups) {
  if (!Array.isArray(groups)) {
    return false;
  }
  return groups.includes('Reyedar');
}

export const isEmpty = (v) => v === null || v === undefined || v === '';

// Step test for numeric values
export const stepTest = (step, translate, msgKey) => ({
  name: 'step',
  message: translate(msgKey),
  test: (value) => {
    if (isEmpty(value)) return true;
    return Math.abs(value * 1000) % (step * 1000) === 0;
  },
});

export const numberFormatTest = (translate) => ({
  name: 'numberFormat',
  message: translate('resultFormDialogFields.validationSchema.invalidFormat'),
  test: function () {
    const original = this.originalValue?.toString() ?? '';
    if (!original) return true;

    // Accepts . or , as decimal separator
    if (/^[+-]?\d+([.,]\d+)?$/.test(original)) {
      // disallow incomplete numbers like "2." or "2,"
      if (original.endsWith('.') || original.endsWith(',')) {
        return this.createError({
          message: translate('resultFormDialogFields.validationSchema.incompleteNumber'),
        });
      }

      const normalized = original.replace(',', '.');
      if (/^-/.test(original) && Number(normalized) === 0) {
        return this.createError({
          message: translate('resultFormDialogFields.validationSchema.invalidFormat'),
        });
      }

      // strip sign for zero-check
      const absVal = original.replace(/^[+-]/, '');

      // forbid leading zeros unless the number is exactly "0" or starts with "0."
      if (/^0\d/.test(absVal)) {
        return this.createError({
          message: translate('resultFormDialogFields.validationSchema.invalidFormat'),
        });
      }

      return true;
    }

    return false;
  },
});

// Enforce integer values
export const integerTest = (translate, msgKey) => ({
  name: 'integer',
  message: translate(msgKey),
  test: (value) => {
    if (isEmpty(value)) return true;
    return Number.isInteger(value);
  },
});

export const validFormatTest = (translate) => ({
  name: 'axisFormat',
  message: translate('resultFormDialogFields.validationSchema.invalidFormat'),
  test: function () {
    const original = this.originalValue?.toString() ?? '';
    if (!original) return true;

    // must be integer digits only
    if (!/^\d+$/.test(original)) return false;

    // forbid leading zeros unless value is exactly "0"
    if (/^0\d/.test(original)) {
      return this.createError({
        message: translate('resultFormDialogFields.validationSchema.invalidFormat'),
      });
    }

    return true;
  },
});

export {
  formatDOB,
  isAdminInReyedarGroupAndUser,
  isSameUser,
  isInReyedarGroup,
  getMaxDate,
  getMinDate,
};
